import { render } from "./CustomInvoiceRowComponent.vue?vue&type=template&id=39cc2b12&scoped=true"
import script from "./CustomInvoiceRowComponent.vue?vue&type=script&lang=js"
export * from "./CustomInvoiceRowComponent.vue?vue&type=script&lang=js"

import "./CustomInvoiceRowComponent.vue?vue&type=style&index=0&id=39cc2b12&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cc2b12"]])

export default __exports__